import { ClipboardCheck, Lightbulb, Rocket, Bot, LineChart } from "lucide-react";

const steps = [
  { icon: ClipboardCheck, title: "Audit", desc: "Deep dive into your website, SEO, ads, funnel and analytics to find growth gaps and quick wins." },
  { icon: Lightbulb, title: "Strategy", desc: "Custom growth roadmap combining SEO, paid ads, content and automation — mapped to your goals." },
  { icon: Rocket, title: "Execution", desc: "Hands-on implementation across channels with weekly progress and transparent communication." },
  { icon: Bot, title: "Automation", desc: "AI-powered workflows for lead follow-ups, CRM updates, reporting and content operations." },
  { icon: LineChart, title: "Reporting & Optimization", desc: "Clear monthly reports, continuous testing and refinement to compound growth over time." },
];

export default function Process() {
  return (
    <section id="process" className="bg-slate-50 border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-bold uppercase tracking-widest text-blue-600">Process</div>
          <h2 className="mt-3 font-display text-3xl md:text-5xl font-bold text-slate-900 tracking-tight">
            A simple, proven 5-step process.
          </h2>
        </div>

        <div className="mt-14 relative">
          <div className="hidden lg:block absolute left-0 right-0 top-8 h-px bg-gradient-to-r from-transparent via-blue-200 to-transparent" />
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
            {steps.map((s, i) => (
              <div
                key={s.title}
                data-testid={`process-step-${i}`}
                className="reveal relative bg-white border border-slate-200 rounded-3xl p-6 hover:border-blue-200 hover:shadow-lg transition-all"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-xl bg-blue-600 text-white grid place-items-center font-display font-bold">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <s.icon className="w-5 h-5 text-blue-600" />
                </div>
                <h3 className="font-display font-bold text-slate-900 text-lg">{s.title}</h3>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
